import { Configuration, PopupRequest } from '@azure/msal-browser';

// Configuração do Azure AD
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || 'your-client-id-here',
    authority: `https://login.microsoftonline.com/${
      process.env.REACT_APP_AZURE_TENANT_ID || 'your-tenant-id'
    }`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: () => {
        // Logs desabilitados por segurança
      },
      logLevel: 0, // Silent
    },
  },
};

// Escopos de acesso
export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'email', 'profile', 'openid'],
};

// Configuração para logout
export const logoutRequest = {
  postLogoutRedirectUri: window.location.origin,
};
